import Index from '@/pages/congroup/Index'
import List from '@/pages/congroup/List'
import Create from '@/pages/congroup/Create'
import Import from '@/pages/congroup/Import'
import Sort from '@/pages/congroup/Sort'
import Modify from '@/pages/congroup/Modify'

var serviceName = process.env.VUE_APP_SERVICE_NAME || 'Nichibyo'

export default {
  path: 'group',
  component: Index,  
  children: [
    {
      path: 'index',
      component: List,
      props: () => ({serviceName: serviceName})
    },
    {
      path: 'create/:extraContactId',
      component: Create
    },
    {
      path: 'import',
      component: Import
    },
    {
      path: 'sort/:extraContactId',
      component: Sort
    },
    {
      path: 'modify/:extraContactId/:id',
      component: Modify
    }
  ]
}

